module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-pocket-marble-run.769479f9.jpg";